// extracted by mini-css-extract-plugin
export default {"pageShell":"page-shell_pageShell__e1NPE"};